import React from 'react'
import MyPayroll from './MyPayroll'


export default function UpdateStudentInformationReport() {
  return (
    <div>
      <MyPayroll />
    </div>
  )
}
